<template>
  <layout title="Industry knowledge Ebooks">
    <JsonLd :entries="jsonLdEntries" />
    <div
      class="relative px-8 pt-8 pb-20 mx-auto xl:px-5 max-w-7xl sm:px-6 lg:pt-10 lg:pb-28"
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="text-3xl font-extrabold leading-9 tracking-tight text-gray-900 sm:text-4xl sm:leading-10"
          >
            eBooks
          </h1>
          <p class="mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
            Explore the latest trends, best practices, and case studies in face
            biometrics.
          </p>
        </div>

        <div class="mt-12 gap-5" v-if="showLoading">
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between"
            :count="3"
          />
          <PuSkeleton
            class="h-96 z-10 rounded-lg flex space-x-4 justify-between mt-6"
            :count="3"
          />
        </div>
        <div v-else>
          <div
            class="grid gap-5 mx-auto mt-12 sm:grid-cols-2 lg:grid-cols-3"
            v-if="ebooks"
            id="elementToScroll"
          >
            <article
              :id="'ebook-' + ebook.id"
              class="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white"
              typeof="Article"
              v-for="(ebook, index) in ebooks.data"
              :key="index"
            >
              <a
                :href="ebook.form_required ? 'ebook/' + ebook.slug : ebook.link"
                :target="!ebook.form_required ? '_blank' : ''"
                class="h-full"
              >
                <meta property="name" :content="ebook.title" />
                <meta property="author" typeof="Person" content="admin" />
                <meta
                  property="dateModified"
                  :content="ebook.updated_at | formatDate"
                />
                <meta
                  class="uk-margin-remove-adjacent"
                  property="datePublished"
                  :content="ebook.created_at | formatDate"
                />
                <div class="flex flex-col justify-between h-full">
                  <div>
                    <div class="shrink-0">
                      <div class="w-full h-48 book" v-if="isTurtl(ebook.link)">
                        <img
                          class="w-full h-48 p-4 absolute top-0 left-0 object-cover first-sheet"
                          :src="aws_image_path + ebook.image"
                          alt=""
                        />
                        <img
                          class="w-full h-48 p-4 object-cover right-sheet"
                          :src="aws_image_path + ebook.image"
                          alt=""
                        />
                      </div>
                      <div v-else>
                        <div class="w-full h-48">
                          <img
                            class="w-full h-48 p-4 object-cover"
                            :src="aws_image_path + ebook.image"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="relative flex flex-col justify-between flex-1 p-6 bg-gray-50"
                    >
                      <div class="flex-1">
                        <h3
                          class="mt-2 text-xl font-semibold leading-7 text-gray-900"
                        >
                          {{ ebook.title }}
                        </h3>
                        <p class="mt-3 text-base leading-6 text-gray-500">
                          {{
                            ebook.description.length > 200
                              ? removeHTMLtags(ebook.description).substring(
                                  0,
                                  200
                                ) + "..."
                              : removeHTMLtags(ebook.description)
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </article>
          </div>
        </div>
        <pagination
          class="mt-10"
          :data="ebooks"
          @changePage="getEbooks"
          elementToScroll="elementToScroll"
        />
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");
const pagination = () =>
  import(
    /* webpackChunkName: "pagination" */ "../Components/Layout/pagination.vue"
  );
import JsonLd from "../Components/SEO/JsonLd.vue";
import { buildCollectionPageSchema } from "../utils/structuredData";

export default {
  props: {
    errors: Object,
  },
  components: { layout, pagination, JsonLd },
  data() {
    return {
      ebooks: null,
      aws_image_path: process.env.MIX_IMAGES_PATH,
      showLoading: true,
    };
  },
  created() {
    this.getEbooks(1);
  },
  computed: {
    jsonLdEntries() {
      return [
        buildCollectionPageSchema({
          title: "eBooks",
          items: (this.ebooks?.data || []).map((ebook) => ({
            name: ebook.title,
            url: ebook.form_required ? `/resources/ebook/${ebook.slug}` : ebook.link,
          })),
        }),
      ];
    },
  },
  methods: {
    removeHTMLtags(text) {
      return text.replace(/(<([^>]+)>)/gi, "");
    },
    getEbooks(page) {
      this.showLoading = true;
      this.axios.get("/api/ebooks?page=" + page).then((response) => {
        this.ebooks = response.data;
        this.showLoading = false;
      });
    },
    isTurtl(url) {
      return url.includes("youverse.turtl.co");
    },
  },
};
</script>
